module.exports = __webpack_public_path__ + "img/slider_4.5297f843.jpg";